import React, { useEffect, useRef, useState } from "react";
import "../Styles/Travelers_favorite.css";
import RajasthanImage from "../Images/rajasthan_pic.png";
import api from "../Api.js";
import { useNavigate } from "react-router-dom";
import DateFormatter from "./Dateformatter";

function Travelers_favorite() {
  const [groupData, setGroupData] = useState([]);
  const sliderRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const getAllGroupData = async () => {
      const response = await api.get("/tours/details?trip_type_id=5");
      setGroupData(response?.data?.data || []);
    };
    getAllGroupData();
  }, []);

  const scrollSlider = (direction) => {
    const scrollAmount = 420;
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: direction === "next" ? scrollAmount : -scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="tf-wrapper">
      {/* Header */}
      <div className="tf-header">
        <h3>🔥 Trending Group Tours</h3>

        <div className="tf-actions">
          <button className="tf-nav-btn" onClick={() => scrollSlider("prev")}>
            ◀
          </button>

          <span
            className="tf-show-more"
            onClick={() => navigate("/tour/grouptour")}
          >
            + Show more
          </span>
                    <button className="tf-nav-btn" onClick={() => scrollSlider("next")}>
            ▶
          </button>
        </div>
      </div>

      {/* Slider */}
      <div className="tf-slider" ref={sliderRef}>
        {groupData?.slice(0, 6).map((item, index) => (
          <div className="tf-card" key={index}>
            <div className="tf-image">
              <img
                src={
                  item?.tour?.images?.find((img) => img.is_featured)?.url ||
                  RajasthanImage
                }
                alt={item?.tour?.title}
              />
              <div className="tf-overlay">
                <h4>{item.tour.title}</h4>
                <span>
                  {item.tour.no_of_days} Days <br />
                  ₹{item.tour.raw_columns.mrp_group}
                </span>
              </div>
            </div>

            <div className="tf-content">
              <p>{item.tour.raw_columns.overview}</p>

              <div className="tf-footer">
                <button
                  onClick={() =>
                    navigate(`/tour/grouptour/${item.tour?.id}`)
                  }
                >
                  View Tour
                </button>

                <small>
                  Last Date:{" "}
                  <DateFormatter
                    dateString={item?.tour?.dates?.booking_end_date}
                  />
                </small>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Travelers_favorite;
